export default __webpack_public_path__ + "2f2e7dc34b9bd11565b6ce04c60d453d.svg";